import { render, staticRenderFns } from "./RecoveryInfo.vue?vue&type=template&id=89ecf90c&scoped=true&"
import script from "./RecoveryInfo.vue?vue&type=script&lang=js&"
export * from "./RecoveryInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryInfo.vue?vue&type=style&index=0&id=89ecf90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ecf90c",
  null
  
)

export default component.exports